module.exports = __webpack_public_path__ + "media/customizations/hylandtrail/back-575f178ffbcebd12294e0eefba056c08.jpg";